/*
* @Author: Abhi Bhatt
* @Date:   2020-06-24 12:35:52
* @Last Modified by:   babysoft08
* @Last Modified time: 2025-06-16 15:46:54
*/
import React from 'react';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import StaticPagesService from './../../services/StaticPagesService/StaticPagesService';
import ContactService from './../../services/ContactService/ContactService';
import USMap from '../../components/Map/USMap';
import us_states from './us_states';
import us_territories from './us_territories';
import GearSpinner from '../../components/GearSpinner/GearSpinner';


const renderHTML = (rawHTML: string) =>
  React.createElement("div", {
    className: "row",
    dangerouslySetInnerHTML: { __html: rawHTML },
  });

const renderHTMLV2 = (rawHTML: string) =>
React.createElement("p", {
  dangerouslySetInnerHTML: { __html: rawHTML },
});

class Contact extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			contact_data:{
				contact_tab : [],
				warehouse_tab: []
			},
			fields: {
				'state_code':'',
				'zip_code':'',
				'search_by':'state',
				'territory':''
			},
			errors: {},
			is_loader: true,
			is_search: false,
			is_searched_content: true,
			searched_content:[],
			api_message:''

		}
		this.staticPagesService = new StaticPagesService();
		this.contactService = new ContactService();
		this.handleStateChange = this.handleStateChange.bind(this);
		this.handleTerritoryChange = this.handleTerritoryChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleValidation = this.handleValidation.bind(this);
		this.handleChangeSearchType = this.handleChangeSearchType.bind(this);
		this.openTab = this.openTab.bind(this);
	}

	componentDidMount() {
		if (
      localStorage.getItem('techtop_user_id') != '' &&
      localStorage.getItem('techtop_user_id') != null
    ) {
			this.setState({company: localStorage.getItem('techtop_user_company')});
    }
	this.openTab();
    this.getContactTabData();
    this.getWarehouseTabData();
	}

	openTab() {
		var hash = window.location.hash;
		if(hash) {
			if(hash === '#locations') {
				hash = '#techtop-warehouse-locations';
			}
			document.querySelector('a[href="' + hash + '"]').click();
		}
	}



	getContactTabData() {
		const permalink = 'new-contact';
		this.staticPagesService.getStaticPage(permalink).then(request=>{
			if(request.status===200) {
				this.setState({is_loader : false});
				this.setState(prevState => ({
				  contact_data: {
				    ...prevState.contact_data,
				    contact_tab: request.data.result.static_page[0].fields
				  }
				}));
			}
		});
	}

	getWarehouseTabData() {
		const permalink = 'warehouse-locations';
		this.staticPagesService.getStaticPage(permalink).then(request=>{
			if(request.status===200) {
				this.setState(prevState => ({
				  contact_data: {
				    ...prevState.contact_data,
				    warehouse_tab: request.data.result.static_page[0].fields
				  }
				}));
			}
		});
	}

	async handleStateChange(selectedOption) {
		this.setState(prevState => ({
		  fields: {
		    ...prevState.fields,
		    state_code: selectedOption.value
		  }
		}));
	}

	async handleTerritoryChange(selectedOption) {
		this.setState(prevState => ({
		  fields: {
		    ...prevState.fields,
		    territory: selectedOption.value
		  }
		}));
	}

	handleChange(field, e) {
		let fields = { ...this.state.fields };
		fields[field] = e.target.value;
		this.setState({ fields });
	}

  handleValidation() {
    let errors = {};
    let formIsValid = true;
    const { fields } = this.state
    if (fields["search_by"] === 'territory' && !fields["territory"]) {
      formIsValid = false;
      errors["territory"] = "Please select your territory.";
    }

    this.setState({ errors });
    return formIsValid;
  }

  handleChangeSearchType() {
  	this.setState({is_search: false,is_searched_content: true,searched_content:[]})
  	this.setState(prevState => ({
	    fields: {
	      ...prevState.fields,
	      search_by: prevState.fields.search_by === 'territory' ? 'state' : 'territory',
	      state_code:'',
	      territory:'',
	      zip_code:''
	    }
	  }));
  }

  handleSubmit(e) {
  	let { fields } = this.state;
    let errors = {};
    e.preventDefault();
    if (this.handleValidation()) {
    	this.setState({is_search : true , is_searched_content : false,searched_content : [], api_message:'' });
    	console.log(this.state.fields);
    	this.contactService.getRep(fields).then(response => {
    		this.setState({is_search : false });
    		const data = response.data;
    		this.setState({api_message:data.message})
    		if(data && data.response === 'success') {
    			this.setState( {searched_content : data.result, is_searched_content : true });
    		}
    	})
    }

  }

	renderContactTab() {
		const { contact_data } = this.state
		let { is_loader } = this.state
		return(
			<React.Fragment>
				<div className="tab-pane active pt-4" id="contact-us">
					{(is_loader) ? (<GearSpinner/>) : renderHTML(contact_data.contact_tab.content)}
				</div>
			</React.Fragment>
		)
	}

	renderFrom() {
		let { fields, errors } = this.state;
		return (
			<React.Fragment>
				{(fields.search_by === 'state') ? (
					<React.Fragment>
						<div className="mb-2">
							<label htmlFor="form-selectInput1" className="form-label">Select Your State</label>
							<Select
								className="custom-select-container"
								classNamePrefix="custom-select"
								options={us_states}
								value={us_states.find(s => s.value === this.state.fields.state_code) || null}
								onChange={this.handleStateChange}
								placeholder="Select your state"
							/>
							{errors.state_code && <span style={{ color: "red" }}>{errors.state_code}</span>}
						</div>
						<div className="mb-2">
							<label htmlFor="zip_code" className="form-label">Enter Your Zip Code</label>
							<input
								type="text"
								className="form-control"
								id="zip_code"
								onChange={(e) => this.handleChange("zip_code", e)}
							/>
						</div>
					</React.Fragment>
				) : (
					<React.Fragment>
						<div className="mb-2">
							<label htmlFor="form-selectInput1" className="form-label">Select Your Territory</label>
							<Select
								className="custom-select-container"
								classNamePrefix="custom-select"
								options={us_territories}
								value={us_territories.find(s => s.value === this.state.fields.territory) || null}
								onChange={this.handleTerritoryChange}
								placeholder="Select your territory"
							/>
							{errors.territory && <span style={{ color: "red" }}>{errors.territory}</span>}
						</div>
					</React.Fragment>
				)}
			</React.Fragment>
		);
	}

	renderRepresentativeDiv() {
		let { is_search, searched_content,is_searched_content, errors, fields, api_message } = this.state;
		return(
			<React.Fragment>
				<div className="col-md-12 col-sm-12 col-xl-4 col-lg-4">
					<div className="row">
						<div className="col-md-12">
							<div className="map-lookup-div">
								<h5>Sales Representative Lookup</h5>
								<form>
									{this.renderFrom()}
									<button type="button" className="btn find-my-rep-btn" onClick={this.handleSubmit} disabled={is_search}>Find my Rep</button>	
									<div className="mb-2 text-center">
										{fields.search_by === 'territory' ? (
										  <Link to="#" onClick={this.handleChangeSearchType.bind(this)}>
										    Search in States
										  </Link>
										) : (
										  <Link to="#" onClick={this.handleChangeSearchType.bind(this)}>
										    Search in Territories
										  </Link>
										)}
									</div>
								</form>	
							</div>
						</div>
						<div className="col-md-12">
						  {is_search ? (
						    <GearSpinner />
						  ) : is_searched_content && searched_content.length > 0 ? (
						    <div className="map-lookup-map-detail">
						      {searched_content.map((value, index) => (
						        <React.Fragment key={index}>
						          {renderHTMLV2(value.content)}
						        </React.Fragment>
						      ))}
						    </div>
						  ) : !is_searched_content && !is_search && searched_content.length === 0 ? (
						    renderHTMLV2('<div class="map-lookup-div text-center"><h5>'+api_message+'</h5></div>')
						  ) : null}
						</div>

					</div>
				</div>
			</React.Fragment>
		)
	}

	renderWarehouseTab() {
		const { contact_data } = this.state;
		return(
			<React.Fragment>
				<div className="tab-pane mt-3" id="techtop-warehouse-locations">
					<div className="row">
						<div className="col-md-12">
							<div className="row">
								<div className="col-md-12 col-sm-12 col-xl-8 col-lg-8">
									<USMap />
								</div>
								{this.renderRepresentativeDiv()}
							</div>
							<div className="company-address">
								{renderHTML(contact_data.warehouse_tab.content)}
								<div className="row pt-3">
									<div className="col-md-6 col-sm-6 col-lg-4 col-xl-4 map_location Dallas">
										<div className="company-address-div">
											<h5>Dallas, Tx</h5>
											<p className="m-0">ROBCO</p>
											<p className="m-0">1523 Crescent Drive Carrollton, TX 75006</p>
											<p className="m-0">Phone: <a href="tel:8004447609">800-444-7609</a></p>
										</div>
									</div>
									<div className="col-md-6 col-sm-6 col-lg-4 col-xl-4 map_location Phoenix">
										<div className="company-address-div">
											<h5>PHOENIX,AZ</h5>
											<p className="m-0">Phoenix Warehouse Company 4022</p>
											<p className="m-0">West Turney Suite A-1 Phoenix, AZ 85019</p>
											<p className="m-0">Phone: <a href="tel:6022782886">602-278-2886</a></p>
										</div>
									</div>
									<div className="col-md-6 col-sm-6 col-lg-4 col-xl-4 map_location Reno">
										<div className="company-address-div">
											<h5>RENO, NV</h5>
											<p className="m-0">Landstar/Advanced Logistics 1285B</p> 
											<p className="m-0">Southern Way Sparks, NV 89431</p>
											<p className="m-0">Phone: <a href="tel:7754320336">775-432-0336</a></p>
										</div>
									</div>
									<div className="col-md-6 col-sm-6 col-lg-4 col-xl-4 map_location Houston">
										<div className="company-address-div">
											<h5>HOUSTON, TX</h5>
											<p className="m-0">BEECO</p>
											<p className="m-0">5630 Guhn Road # 100 Houston, TX 77040</p>
											<p className="m-0">Phone: <a href="tel:8004447609">800-444-7609</a></p>
										</div>
									</div>
									<div className="col-md-6 col-sm-6 col-lg-4 col-xl-4 map_location Fresno">
										<div className="company-address-div">
											<h5>FRESNO, CA</h5>
											<p className="m-0">Engineered Industrial Products, Inc</p> 
											<p className="m-0">1816 S Van Ness Ave. Fresno, CA 93721</p>
											<p className="m-0">Phone: <a href="tel:5593657949">559-365-7949</a></p>
										</div>
									</div>
									<div className="col-md-6 col-sm-6 col-lg-4 col-xl-4 Cleveland">
										<div className="company-address-div">
											<h5>CLEVELAND, OH</h5>
											<p className="m-0">IMC</p>
											<p className="m-0">4540 Glennbrook Dr. Willoughby, OH 44094</p>
											<p className="m-0">Phone: <a href="tel:4409515703">440-951-5703 x8</a></p>
										</div>
									</div>
									<div className="col-md-6 col-sm-6 col-lg-4 col-xl-4 map_location Odessa">
										<div className="company-address-div">
											<h5>ODESSA, TX</h5>
											<p className="m-0">Diversified Warehouse, Inc</p> 
											<p className="m-0">635 Industrial Ave Odessa, TX 79761</p>
											<p className="m-0">Phone: <a href="tel:4323320416">432-332-0416</a></p>
										</div>
									</div>
									<div className="col-md-6 col-sm-6 col-lg-4 col-xl-4 map_location Portland">
										<div className="company-address-div">
											<h5>PORTLAND, OR</h5>
											<p className="m-0">Northwest Warehouse</p> 
											<p className="m-0">7615 N. Upland Dr. Portland, OR 97203</p>
											<p className="m-0">Phone: <a href="tel:5037354082">503-735-4082</a></p>
										</div>
									</div>
									<div className="col-md-6 col-sm-6 col-lg-4 col-xl-4 map_location Itasca">
										<div className="company-address-div">
											<h5>ITASCA, IL</h5>
											<p className="m-0">4C Logistics</p> 
											<p className="m-0">921 Ardmore Ave Itasca, IL 60143</p>
											<p className="m-0">Phone: <a href="tel:6307759103">630-775-9103</a></p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}

	render() {
		let contact_data = this.state.contact_data;
		const { company } = this.state;
		return(
			<React.Fragment>
				<main className="techtop-middle-div">
					<section className="techtop-contact-section py-5">	
						<div className="container">
							<div className="row">
								<div className="col-md-12">
									<ul className="nav nav-tabs card-header-tabs" data-bs-tabs="tabs">
										<li className="nav-item">
											<a className="nav-link active" aria-current="true" data-bs-toggle="tab" href="#contact-us">Contact us</a>
										</li>
										<li className="nav-item">
											<a className="nav-link" data-bs-toggle="tab" href="#techtop-warehouse-locations">Techtop Warehouse Locations</a>
										</li>
									</ul>
								</div>
								<div className="col-md-12">
									<div className="tab-content contact-section">
										{this.renderContactTab()}
										{this.renderWarehouseTab()}
									</div>
								</div>	
							</div>	
							
						</div>
					</section>
				</main>
			</React.Fragment>
		)
	}
}

export default Contact;